// extracted by mini-css-extract-plugin
export default {"listItem":"Autocomplete_listItem__CRaoL","listItemIcon":"Autocomplete_listItemIcon__8wvVZ","selectedValueStack":"Autocomplete_selectedValueStack__nXRPq"};